import * as THREE from "three";
import CustomZObject from './CustomZObject.js';

export default class TextureLoader extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.loader = new THREE.TextureLoader();

        this.newOutlet("texture");
    }

    loadImage(hash) {
        if (hash === this.imageHash && this.texture) {
            this.sendMessage("texture", this.texture);
            return;
        }
        this.imageHash = hash;
        let url = "https://zequencer.io/ipfs/" + hash;
        this.sendMessage("texture", this.loader.load(url,
                                                     (texture) => {
                                                         this.texture = texture;
                                                     }));
    }

    getJson() {
        return {
            ... super.getJson(),
            imageHash: this.imageHash
        };
    }

    fromJson(json, isCopy) {
        super.fromJson(json, isCopy);
        this.imageHash = json.imageHash;
        console.log("FROM JSON IMAGE HASH=", json.imageHash);
    }
}
